import { render, staticRenderFns } from "./PriceDetail.vue?vue&type=template&id=e149ee2c&scoped=true"
import script from "./PriceDetail.vue?vue&type=script&lang=js"
export * from "./PriceDetail.vue?vue&type=script&lang=js"
import style0 from "./PriceDetail.vue?vue&type=style&index=0&id=e149ee2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e149ee2c",
  null
  
)

export default component.exports